import { Injectable } from '@angular/core';
import { MaterialConfiguration } from './material-configuration';
import { TranslateHandlebarsPipe } from 'app/shared/pipes/translate-handlebars.pipe';
import { VideoCardConfiguration } from './video-card-configuration';
import { EbookCardConfiguration } from './ebook-card-configuration';
import { ElearningCardConfiguration } from './elearning-card-configuration';
import { LicenseService } from 'app/core/services/license.service';
import { GoogleSlidesCardConfiguration } from './google-slides-card-configuration';
import { IspringCardConfiguration } from './ispring-card-configuration';
import { ArchiveCardConfiguration } from './archive-card-configuration';
import { CertificateService } from 'app/core/components/content/certificate/certificate.service';
import { SmartModalService } from 'app/core/services/smart-modal.service';
import { ParticipationCertificateCardConfiguration } from 'app/core/components/workflow-new/material/configurations/participation-certificate-card-configuration';
import { ELearningCompletionCertificateCardConfiguration } from 'app/core/components/workflow-new/material/configurations/eLearning-certificate-card-configuration';
import { ExamCertificateCardConfiguration } from 'app/core/components/workflow-new/material/configurations/exam-certificate-card-configuration';
import { UnknownCardConfiguration } from 'app/core/components/workflow-new/material/configurations/unknown-card-configuration';
import { ExternalEbookConfiguration } from './external-ebook-configuration';
import { ExternalPodcastConfiguration } from './external-podcast-configuration';
import { ExternalElearningConfiguration } from './external-elearning-configuration';
import { ExternalPresentationConfiguration } from './external-presentation-configuration';
import { ExternalVideoConfiguration } from './external-video-configuration';
import { ExternalArticleConfiguration } from './external-article-configuration';
import { ExternalLabsConfiguration } from './external-labs-configuration.ts';
import { OnlineExamCardConfiguration } from './online-exam-card-config';
import {AIProctoredExamCardConfiguration} from './ai-proctored-exam';

@Injectable()
export class MaterialConfigurationService {
  getConf(course): MaterialConfiguration {
    let result;
    switch (course.type) {
      case 'video':
        result = new VideoCardConfiguration(course);
        break;
      case 'ebook':
        result = new EbookCardConfiguration(course);
        break;
      case 'scormcloud':
      case 'scorm':
        result = new ElearningCardConfiguration(course);
        break;
      case 'googleslides':
        result = new GoogleSlidesCardConfiguration(course);
        break;
      case 'ispring':
        result = new IspringCardConfiguration(course);
        break;
      case 'archive':
        result = new ArchiveCardConfiguration(course);
        break;
      case 'participation-certificate':
        result = new ParticipationCertificateCardConfiguration(course, this.certificateService, this.modalService);
        break;
      case 'eLearning-certificate':
        result = new ELearningCompletionCertificateCardConfiguration(course, this.certificateService, this.modalService, this.translateHandlebarsPipe);
        break;
      case 'exam-certificate':
        result = new ExamCertificateCardConfiguration(course, this.certificateService, this.translateHandlebarsPipe);
        break;
      case 'online-exam':
        result = new OnlineExamCardConfiguration(course, this.translateHandlebarsPipe);
        break;
      case 'ai-proctored-exam':
        result = new AIProctoredExamCardConfiguration(course, this.translateHandlebarsPipe);
        break;
      case 'external-ebook':
        result = new ExternalEbookConfiguration(course, this.translateHandlebarsPipe);
        break;
      case 'external-podcast':
        result = new ExternalPodcastConfiguration(course, this.translateHandlebarsPipe);
        break;
      case 'external-eLearning':
        result = new ExternalElearningConfiguration(course, this.translateHandlebarsPipe);
        break;
      case 'external-presentation':
        result = new ExternalPresentationConfiguration(course, this.translateHandlebarsPipe);
        break;
      case 'external-video':
        result = new ExternalVideoConfiguration(course, this.translateHandlebarsPipe);
        break;
      case 'external-article':
        result = new ExternalArticleConfiguration(course, this.translateHandlebarsPipe);
        break;
      case 'external-lab':
        result = new ExternalLabsConfiguration(course, this.translateHandlebarsPipe);
        break;
      case 'unknown':
        result = new UnknownCardConfiguration(course);
        break;
      default:
        throw new Error(`Unknown type ${course.type}`);
    }
    return result;
  }

  constructor(private certificateService: CertificateService, private modalService: SmartModalService, private translateHandlebarsPipe: TranslateHandlebarsPipe) { }

}





// WEBPACK FOOTER //
// ./src/app/core/components/workflow-new/material/configurations/material-configuration.service.ts